import { Size } from '@ps/web-core-enums';
import { Translation, useScreenSize } from '@ps/web-shared-components';
import React from 'react';

import { useLayout } from '@swf/sports/providers/LayoutProvider';

import type { Props as HorizontalMenuItemProps } from '../HorizontalMenuItem/HorizontalMenuItem';
import HorizontalMenuItem from '../HorizontalMenuItem/HorizontalMenuItem';

import { TXTWCL_Sports } from './SportsMenuButton.messages.json';
import styles from './SportsMenuButton.scss';

type Props = Partial<HorizontalMenuItemProps>;

const SportsMenuButton: React.FC<Props> = () => {
  const { showNavigationSection, setShowNavigationSection } = useLayout();
  const { greaterThan } = useScreenSize();
  const isDesktopScreenSize = greaterThan(Size.Large);

  if (isDesktopScreenSize) return;

  return (
    <HorizontalMenuItem
      key="sports-menu"
      icon="sports-menu"
      className={styles.sportsMenuButton}
      text={<Translation {...TXTWCL_Sports} />}
      onClick={() => {
        setShowNavigationSection(!showNavigationSection);
      }}
    />
  );
};

export default SportsMenuButton;
